import { render, staticRenderFns } from "./ModalAjudaCidsCiaps.vue?vue&type=template&id=3a20e5a4&scoped=true"
import script from "./ModalAjudaCidsCiaps.vue?vue&type=script&lang=js"
export * from "./ModalAjudaCidsCiaps.vue?vue&type=script&lang=js"
import style0 from "./ModalAjudaCidsCiaps.vue?vue&type=style&index=0&id=3a20e5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20e5a4",
  null
  
)

export default component.exports